import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
	Dialog,
	DialogActions,
	DialogContent,
	withMobileDialog,
	withStyles,
	Tabs,
	Tab,
} from '@material-ui/core'
import { toggleDialog, toggleState, selectUser } from 'actions/users'
import Button from 'components/theme/Button'
import Users from './Users'
import Invites from './Invites'
import User from './User'
import AssignmentPools from './AssignmentPools'

class UsersAndInvites extends Component {
	render() {
		const {
			fullScreen,
			open,
			toggleDialog,
			classes,
			dialogState,
			vr_role,
			toggleState,
			userSelected,
			selectUser,
		} = this.props

		const dialogStateMap = {
			assignmentPool: 0,
			users: 1,
			invites: 2,
			0: 'assignmentPool',
			1: 'users',
			2: 'invites',
		}

		return (
			<Dialog
				fullScreen={fullScreen}
				open={open}
				onClose={() => toggleDialog(false)}
				fullWidth
				maxWidth="lg"
				PaperProps={{
					style: {
						borderRadius: 22,
						textAlign: 'center',
						padding: 20,
					},
				}}
				classes={{ paperFullWidth: classes.paperFullWidth }}
			>
				<DialogContent>
					{vr_role === 'acctowner' && !userSelected ? (
						<Tabs
							centered
							value={dialogStateMap[dialogState]}
							onChange={(e, val) => toggleState(dialogStateMap[val])}
						>
							<Tab label="Assignment Pool" />
							<Tab label="Users" />
							<Tab label="Invites" />
						</Tabs>
					) : !userSelected ? (
						<div
							style={{
								textAlign: 'left',
								fontSize: 27,
								fontWeight: 'bold',
								color: '#014c94',
							}}
						>
							USERS
						</div>
					) : null}
					{userSelected ? (
						<User modal username={userSelected} />
					) : dialogState === 'invites' ? (
						<Invites />
					) : dialogState === 'assignmentPool' ? (
						<AssignmentPools />
					) : (
						<Users />
					)}
				</DialogContent>
				<DialogActions>
					<Button
						onClick={() => {
							toggleDialog(false)
							selectUser(null)
						}}
					>
						Close
					</Button>
				</DialogActions>
			</Dialog>
		)
	}
}

export default connect(
	(state) => ({
		open: state.users.dialogOpen,
		dialogState: state.users.dialogState,
		invites: state.data['account/reservation']
			? Object.values(state.data['account/reservation'])
			: [],
		loadStatus: state.loadStatus.invites,
		vr_role:
			state.auth.session &&
			state.auth.session.idToken &&
			state.auth.session.idToken.payload &&
			state.auth.session.idToken.payload['custom:vr_role'],
		userSelected: state.users.userSelected,
	}),
	(dispatch) =>
		bindActionCreators({ toggleDialog, toggleState, selectUser }, dispatch),
)(
	withStyles((theme) => ({
		notchedOutline: {
			borderRadius: 28,
			paddingLeft: '40px !important',
		},
		titleText: {
			marginBottom: 14,
			fontSize: 25,
			fontWeight: 'bold',
			color: '#014c94',
			[theme.breakpoints.down('sm')]: {
				fontSize: 19,
			},
		},
		paperFullWidth: { height: '100%' },
		paper: {
			border: '1px solid #adadad',
			borderRadius: 35,
		},
	}))(withMobileDialog()(UsersAndInvites)),
)
